import { WidgetContext } from '../provider/widget-provider';
import React, { Fragment, useContext } from 'react';
import { Button, Icon, IconButton, Tooltip } from '@material-ui/core';
import { updateActiveWidgetsByRoomService } from '@/widget-editor/utilities';

export const WidgetController = ({ roomId }: { roomId: string }) => {
  // const { loadWidgets } = useWidgets(roomId, false);
  const { reloadWidgets } = useContext(WidgetContext);

  return (
    <WidgetContext.Consumer>
      {({ roomId, widgets, isModerator, setModerating, moderating }) =>
        isModerator() ? (
          moderating ? (
            <Fragment>
              <Button
                color="default"
                size="small"
                onClick={() => {
                  reloadWidgets();
                  setModerating(false);
                }}
              >
                Cancel
              </Button>{' '}
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={() => {
                  updateActiveWidgetsByRoomService(roomId, widgets);
                  setModerating(false);
                }}
              >
                Apply
              </Button>
            </Fragment>
          ) : (
            <Tooltip title="Manage widgets">
              <IconButton
                onClick={() => {
                  reloadWidgets();
                  setModerating((prev) => !prev);
                }}
              >
                <Icon>settings</Icon>
              </IconButton>
            </Tooltip>
          )
        ) : null
      }
    </WidgetContext.Consumer>
  );
};
